module.exports = __webpack_public_path__ + "img/logo-footer.5d9a8890.png";